import { render, staticRenderFns } from "./RegimenCondominio.vue?vue&type=template&id=3d95d52b&scoped=true&"
import script from "./RegimenCondominio.vue?vue&type=script&lang=js&"
export * from "./RegimenCondominio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95d52b",
  null
  
)

export default component.exports